"use strict";

exports.__esModule = true;
exports.ChangePartInstanceUserAction = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _ChangePartInstanceActionElement = require("./ChangePartInstanceActionElement");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var ChangePartInstanceUserAction = exports.ChangePartInstanceUserAction = {
  name: "ChangePartInstance",
  icon: "add",
  label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "ChangePartInstanceUserActionDefinition.label",
    defaultMessage: "Change Part Instance"
  }),
  description: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "ChangePartInstanceUserActionDefinition.description",
    defaultMessage: "Enables user to change part instance"
  }),
  requiresContexts: ["device"],
  requiresProps: [],
  components: {
    Element: _ChangePartInstanceActionElement.ChangePartInstanceActionElement
  }
};